/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions, IFilterService, ILogService} from 'angular';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {TSBemerkungScope} from '../../../models/enums/TSBemerkungScope';
import {getTSBemerkungSichtbarkeitValues, TSBemerkungSichtbarkeit} from '../../../models/enums/TSBemerkungSichtbarkeit';
import TSBenutzerBemerkung from '../../../models/TSBenutzerBemerkung';
import RoleUtilService from '../../service/RoleUtilService';
import SchadenfallModelManager from '../../service/SchadenfallModelManager';
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;

declare let require: any;
declare let angular: any;
let template = require('./dv-bemerkung-erfassen.html');
require('./dv-bemerkung-erfassen.scss');
let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');

export class DVBemerkungErfassenComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        schadenfallId: '<',
        onSuccess: '&',
        scope: '<',

    };
    template = template;
    controller = DVBemerkungErfassenController;
    controllerAs = 'vm';
}

export class DVBemerkungErfassenController {

    schadenfallId: string;
    bemerkung: string;
    onSuccess: (paramObj: any) => void;
    scope: TSBemerkungScope;
    sichtbarkeit: TSBemerkungSichtbarkeit = this.getDefaultSichtbarkeit();

    static $inject: any[] = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', 'SchadenfallModelManager', 'AuthServiceRS'];
    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private roleUtilService: RoleUtilService,
                private $window: IWindowService,
                private schadenfallModelManager: SchadenfallModelManager,
                private authServiceRS: AuthServiceRS) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {

    }

    public saveBemerkung() {
        if (this.bemerkung && this.schadenfallId) {
            let newBemerkung = new TSBenutzerBemerkung();
            newBemerkung.bemerkung = this.bemerkung;
            newBemerkung.scope = this.scope;
            newBemerkung.sichtbarkeit = this.sichtbarkeit;
            this.schadenfallModelManager.saveBemerkung(newBemerkung, this.schadenfallId).then((bemerkungResp: TSBenutzerBemerkung) => {
                this.bemerkung = '';
                this.onSuccess({bemerkung: bemerkungResp});
            });
        } else {
            this.$log.debug('bemerkung or schadenfallId was empty');
        }
    }

    private getTSBemerkungSichtbarkeitValues(): Array<TSBemerkungSichtbarkeit> {
        return getTSBemerkungSichtbarkeitValues();
    }

    private getDefaultSichtbarkeit(): TSBemerkungSichtbarkeit {
        if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles())) {
            return TSBemerkungSichtbarkeit.FONDSSUISSE;
        } else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAnlaufstelleRoles())) {
            return TSBemerkungSichtbarkeit.INTERN;
        }
        return TSBemerkungSichtbarkeit.ALLE;
    }

    private isSichtbarkeitVisible(sichtbarkeit: any): boolean {
        if (sichtbarkeit === TSBemerkungSichtbarkeit.FONDSSUISSE) {
            return this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles());
        }
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-bemerkung-erfassen/dv-bemerkung-erfassen.ts